import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { i18nResources as filterBarI18n } from "@arcteryx/components-filterbar";
import { i18nResources as formI18n } from "@arcteryx/components-form";
import { i18nResources as productTileI18n } from "@arcteryx/components-product-tile";
import { i18nResources as containerSearchI18n } from "@arcteryx/container-search";

const addResourceBundle = (bundle, namespace) => {
  Object.keys(bundle).forEach(language => {
    i18n.addResourceBundle(language, namespace, bundle[language][namespace]);
  });
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    ns: ["components-filterbar", "container-search", "components-form", "components-product-tile"],
    defaultLanguage: "en",
    keySeparator: false,
    nsSeparator: false,
    returnEmptyString: false,
    react: {
      wait: true,
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
  });

addResourceBundle(filterBarI18n, "components-filterbar");
addResourceBundle(formI18n, "components-form");
addResourceBundle(productTileI18n, "components-product-tile");
addResourceBundle(containerSearchI18n, "container-search");

export default i18n;
